<div [ngClass]="params.value === params.highlight ? 'ag-cell-value name-field-table text-color-primary' : 'ag-cell-value'" (click)="nameHandler()">
    {{ params.value }}
</div>
